import React from 'react'
import SubresellerLoginComponent from 'components/Panel/Subreseller/Login'
const SubresellerLoginContainer = () => {
  return (
    <SubresellerLoginComponent/>
  )
}

export default SubresellerLoginContainer